const flagContext = require.context('./flags', false, /\.svg$/)

export const FLAG_BY_COUNTRY = flagContext.keys().reduce((accumulator, path) => {
    const code = path.replace('./', '').replace('.svg', '').toLowerCase()
    accumulator[code] = flagContext(path)
    return accumulator
}, {})

export const LANGUAGE_CATALOG = [
    { code: 'af', flagCode: 'za', namePl: 'Afrikaans', nameEn: 'Afrikaans' },
    { code: 'sq', flagCode: 'al', namePl: 'Albański', nameEn: 'Albanian' },
    { code: 'am', flagCode: 'et', namePl: 'Amharski', nameEn: 'Amharic' },
    { code: 'en', flagCode: 'gb', namePl: 'Angielski', nameEn: 'English' },
    { code: 'en-us', flagCode: 'us', namePl: 'Angielski (USA)', nameEn: 'English (US)' },
    { code: 'ar', flagCode: 'sa', namePl: 'Arabski', nameEn: 'Arabic' },
    { code: 'az', flagCode: 'az', namePl: 'Azerbejdżański', nameEn: 'Azerbaijani' },
    { code: 'eu', flagCode: 'es', namePl: 'Baskijski', nameEn: 'Basque' },
    { code: 'bn', flagCode: 'bd', namePl: 'Bengalski', nameEn: 'Bengali' },
    { code: 'be', flagCode: 'by', namePl: 'Białoruski', nameEn: 'Belarusian' },
    { code: 'my', flagCode: 'mm', namePl: 'Birmański', nameEn: 'Burmese' },
    { code: 'bs', flagCode: 'ba', namePl: 'Bośniacki', nameEn: 'Bosnian' },
    { code: 'bg', flagCode: 'bg', namePl: 'Bułgarski', nameEn: 'Bulgarian' },
    { code: 'zh', flagCode: 'cn', namePl: 'Chiński', nameEn: 'Chinese' },
    { code: 'zh-tw', flagCode: 'tw', namePl: 'Chiński tradycyjny', nameEn: 'Chinese (Traditional)' },
    { code: 'hr', flagCode: 'hr', namePl: 'Chorwacki', nameEn: 'Croatian' },
    { code: 'cs', flagCode: 'cz', namePl: 'Czeski', nameEn: 'Czech' },
    { code: 'da', flagCode: 'dk', namePl: 'Duński', nameEn: 'Danish' },
    { code: 'et', flagCode: 'ee', namePl: 'Estoński', nameEn: 'Estonian' },
    { code: 'fo', flagCode: 'fo', namePl: 'Farerski', nameEn: 'Faroese' },
    { code: 'fi', flagCode: 'fi', namePl: 'Fiński', nameEn: 'Finnish' },
    { code: 'fr', flagCode: 'fr', namePl: 'Francuski', nameEn: 'French' },
    { code: 'gl', flagCode: 'es', namePl: 'Galicyjski', nameEn: 'Galician' },
    { code: 'el', flagCode: 'gr', namePl: 'Grecki', nameEn: 'Greek' },
    { code: 'ka', flagCode: 'ge', namePl: 'Gruziński', nameEn: 'Georgian' },
    { code: 'ha', flagCode: 'ng', namePl: 'Hausa', nameEn: 'Hausa' },
    { code: 'he', flagCode: 'il', namePl: 'Hebrajski', nameEn: 'Hebrew' },
    { code: 'hi', flagCode: 'in', namePl: 'Hindi', nameEn: 'Hindi' },
    { code: 'es', flagCode: 'es', namePl: 'Hiszpański', nameEn: 'Spanish' },
    { code: 'es-mx', flagCode: 'mx', namePl: 'Hiszpański (Meksyk)', nameEn: 'Spanish (Mexico)' },
    { code: 'id', flagCode: 'id', namePl: 'Indonezyjski', nameEn: 'Indonesian' },
    { code: 'ga', flagCode: 'ie', namePl: 'Irlandzki', nameEn: 'Irish' },
    { code: 'is', flagCode: 'is', namePl: 'Islandzki', nameEn: 'Icelandic' },
    { code: 'ja', flagCode: 'jp', namePl: 'Japoński', nameEn: 'Japanese' },
    { code: 'ca', flagCode: 'es', namePl: 'Kataloński', nameEn: 'Catalan' },
    { code: 'kk', flagCode: 'kz', namePl: 'Kazachski', nameEn: 'Kazakh' },
    { code: 'km', flagCode: 'kh', namePl: 'Khmerski', nameEn: 'Khmer' },
    { code: 'ky', flagCode: 'kg', namePl: 'Kirgiski', nameEn: 'Kyrgyz' },
    { code: 'ko', flagCode: 'kr', namePl: 'Koreański', nameEn: 'Korean' },
    { code: 'lo', flagCode: 'la', namePl: 'Laotański', nameEn: 'Lao' },
    { code: 'lt', flagCode: 'lt', namePl: 'Litewski', nameEn: 'Lithuanian' },
    { code: 'lb', flagCode: 'lu', namePl: 'Luksemburski', nameEn: 'Luxembourgish' },
    { code: 'lv', flagCode: 'lv', namePl: 'Łotewski', nameEn: 'Latvian' },
    { code: 'mk', flagCode: 'mk', namePl: 'Macedoński', nameEn: 'Macedonian' },
    { code: 'ms', flagCode: 'my', namePl: 'Malajski', nameEn: 'Malay' },
    { code: 'mt', flagCode: 'mt', namePl: 'Maltański', nameEn: 'Maltese' },
    { code: 'mn', flagCode: 'mn', namePl: 'Mongolski', nameEn: 'Mongolian' },
    { code: 'ne', flagCode: 'np', namePl: 'Nepalski', nameEn: 'Nepali' },
    { code: 'nl', flagCode: 'nl', namePl: 'Niderlandzki', nameEn: 'Dutch' },
    { code: 'de', flagCode: 'de', namePl: 'Niemiecki', nameEn: 'German' },
    { code: 'no', flagCode: 'no', namePl: 'Norweski', nameEn: 'Norwegian' },
    { code: 'hy', flagCode: 'am', namePl: 'Ormiański', nameEn: 'Armenian' },
    { code: 'fa', flagCode: 'ir', namePl: 'Perski', nameEn: 'Persian' },
    { code: 'pl', flagCode: 'pl', namePl: 'Polski', nameEn: 'Polish' },
    { code: 'pt', flagCode: 'pt', namePl: 'Portugalski', nameEn: 'Portuguese' },
    { code: 'pt-br', flagCode: 'br', namePl: 'Portugalski (Brazylia)', nameEn: 'Portuguese (Brazil)' },
    { code: 'rm', flagCode: 'ch', namePl: 'Romansz', nameEn: 'Romansh' },
    { code: 'ro', flagCode: 'ro', namePl: 'Rumuński', nameEn: 'Romanian' },
    { code: 'ru', flagCode: 'ru', namePl: 'Rosyjski', nameEn: 'Russian' },
    { code: 'sr', flagCode: 'rs', namePl: 'Serbski', nameEn: 'Serbian' },
    { code: 'sk', flagCode: 'sk', namePl: 'Słowacki', nameEn: 'Slovak' },
    { code: 'sl', flagCode: 'si', namePl: 'Słoweński', nameEn: 'Slovenian' },
    { code: 'sw', flagCode: 'ke', namePl: 'Suahili', nameEn: 'Swahili' },
    { code: 'si', flagCode: 'lk', namePl: 'Syngaleski', nameEn: 'Sinhala' },
    { code: 'tl', flagCode: 'ph', namePl: 'Tagalski', nameEn: 'Tagalog' },
    { code: 'th', flagCode: 'th', namePl: 'Tajski', nameEn: 'Thai' },
    { code: 'tg', flagCode: 'tj', namePl: 'Tadżycki', nameEn: 'Tajik' },
    { code: 'tr', flagCode: 'tr', namePl: 'Turecki', nameEn: 'Turkish' },
    { code: 'tk', flagCode: 'tm', namePl: 'Turkmeński', nameEn: 'Turkmen' },
    { code: 'uk', flagCode: 'ua', namePl: 'Ukraiński', nameEn: 'Ukrainian' },
    { code: 'ur', flagCode: 'pk', namePl: 'Urdu', nameEn: 'Urdu' },
    { code: 'uz', flagCode: 'uz', namePl: 'Uzbecki', nameEn: 'Uzbek' },
    { code: 'hu', flagCode: 'hu', namePl: 'Węgierski', nameEn: 'Hungarian' },
    { code: 'vi', flagCode: 'vn', namePl: 'Wietnamski', nameEn: 'Vietnamese' },
    { code: 'it', flagCode: 'it', namePl: 'Włoski', nameEn: 'Italian' },
    { code: 'cy', flagCode: 'gb', namePl: 'Walijski', nameEn: 'Welsh' }
]

export const LANGUAGE_BY_CODE = LANGUAGE_CATALOG.reduce((accumulator, language) => {
    accumulator[language.code] = language
    return accumulator
}, {})

const getUiLanguage = (uiLanguage) => {
    if (uiLanguage) {
        return uiLanguage
    }
    if (typeof window !== 'undefined') {
        return localStorage.getItem('ahpLanguage') || 'pl'
    }
    return 'pl'
}

export const getLanguageFlag = (code) => {
    const normalized = (code || '').trim().toLowerCase()
    if (!normalized) {
        return null
    }
    const catalogEntry = LANGUAGE_BY_CODE[normalized]
    if (catalogEntry) {
        return FLAG_BY_COUNTRY[catalogEntry.flagCode] || FLAG_BY_COUNTRY[normalized] || null
    }
    const baseCode = normalized.split('-')[0]
    const baseEntry = LANGUAGE_BY_CODE[baseCode]
    if (baseEntry) {
        return FLAG_BY_COUNTRY[normalized] || FLAG_BY_COUNTRY[baseEntry.flagCode] || null
    }
    return FLAG_BY_COUNTRY[normalized] || FLAG_BY_COUNTRY[baseCode] || null
}

export const getLanguageLabel = (code, uiLanguage) => {
    const normalized = (code || '').trim().toLowerCase()
    const catalogEntry = LANGUAGE_BY_CODE[normalized]
    if (!catalogEntry) {
        return normalized || code
    }
    return getUiLanguage(uiLanguage) === 'en' ? catalogEntry.nameEn : catalogEntry.namePl
}

export const getLanguageDropdownOptions = (codes, { uiLanguage, exclude = [] } = {}) => {
    const excluded = new Set((exclude || []).map((item) => (item || '').trim().toLowerCase()))
    return [...new Set((codes || []).map((code) => (code || '').trim().toLowerCase()).filter(Boolean))]
        .filter((code) => !excluded.has(code))
        .map((code) => {
            const flag = getLanguageFlag(code)
            return {
                key: code,
                value: code,
                text: getLanguageLabel(code, uiLanguage),
                image: flag ? { src: flag } : undefined
            }
        })
}

export const getCatalogLanguageOptions = ({ uiLanguage, exclude = [] } = {}) => {
    const options = getLanguageDropdownOptions(
        LANGUAGE_CATALOG.map((language) => language.code),
        { uiLanguage, exclude }
    )
    return options.sort((a, b) => a.text.localeCompare(b.text, getUiLanguage(uiLanguage) === 'en' ? 'en' : 'pl'))
}
